module.exports = __webpack_public_path__ + "img/home_slider_13.36d434bc.jpg";